import { useCallback, useEffect } from "react";

export function useCapturingFilesFromDocument(handleFiles: (files: (File | null)[]) => void) {
  const extractFiles = useCallback(
    (event: React.ClipboardEvent<HTMLDivElement> | ClipboardEvent): File[] => {
      
      if (event.clipboardData == null) return []
      const items = Array.from(event.clipboardData.items)
      const containImages = items.find(i => i.type.startsWith('image/'));
      if(!containImages) return [];

      /* prevent default only for images to avoid non functional text pasting 
         to text fields */
      event.preventDefault()

      const files: File[] = items
        .map((item) => item.getAsFile())
        .filter((file): file is File => !!file)
      return files
    },
    []
  )

  useEffect(() => {
    const handleDocumentPaste = (event: ClipboardEvent) => {
      handleFiles(extractFiles(event))
    }
    document.addEventListener('paste', handleDocumentPaste)
    return () => {
      document.removeEventListener('paste', handleDocumentPaste)
    }
  }, [extractFiles, handleFiles])
}